/**
 * Module-level flag used to signal intentional programmatic navigation
 * that should bypass the beforeRemove logout-modal guard in MainLayoutScreen.web.tsx.
 *
 * Set `intentionalNavFlag.current = true` immediately before calling
 * navigation.navigate() from any child component inside MainLayoutScreen
 * (e.g. DashboardShiftSection end-shift logout).
 */
export const intentionalNavFlag = { current: false };